var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playlist-notify",style:({'opacity': _vm.flagNotify ? 1 : 0}),domProps:{"innerHTML":_vm._s(_vm.textNotify)}})
}
var staticRenderFns = []

export { render, staticRenderFns }